function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 6");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "5.709%",
  y1: "-3.224%",
  x2: "98.47%",
  y2: "108.103%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0F0F0",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2EDFD",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "19.8232627%",
  y1: "65.8067294%",
  x2: "124.189238%",
  y2: "65.8067294%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9A6B",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7E80",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "19.8232627%",
  y1: "65.8067294%",
  x2: "124.189238%",
  y2: "65.8067294%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9A6B",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7E80",
  offset: "100%"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(0.403679, 0.089278)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M164.056846,162.673392 C135.825211,154.558193 97.6646355,158.733483 83.4010508,162.673392 C62.0056743,168.583256 44.791686,161.77826 27.6171838,138.328942 C10.4426815,114.879625 -12.6479573,99.4971716 8.39810731,56.7448024 C29.4441719,13.9924332 93.4587439,31.6211901 132.425048,27.5016118 C171.391352,23.3820336 218.311367,28.5160397 207.172048,66.1382203 C196.03273,103.760401 215.292647,113.489103 206.68131,140.693072 C200.940418,158.829051 186.732263,166.155824 164.056846,162.673392 Z",
  id: "community-a",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.056846,162.673392 C135.825211,154.558193 97.6646355,158.733483 83.4010508,162.673392 C62.0056743,168.583256 44.791686,161.77826 27.6171838,138.328942 C10.4426815,114.879625 -12.6479573,99.4971716 8.39810731,56.7448024 C29.4441719,13.9924332 93.4587439,31.6211901 132.425048,27.5016118 C171.391352,23.3820336 218.311367,28.5160397 207.172048,66.1382203 C196.03273,103.760401 215.292647,113.489103 206.68131,140.693072 C200.940418,158.829051 186.732263,166.155824 164.056846,162.673392 Z",
  id: "community-a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.056846,162.673392 C135.825211,154.558193 97.6646355,158.733483 83.4010508,162.673392 C62.0056743,168.583256 44.791686,161.77826 27.6171838,138.328942 C10.4426815,114.879625 -12.6479573,99.4971716 8.39810731,56.7448024 C29.4441719,13.9924332 93.4587439,31.6211901 132.425048,27.5016118 C171.391352,23.3820336 218.311367,28.5160397 207.172048,66.1382203 C196.03273,103.760401 215.292647,113.489103 206.68131,140.693072 C200.940418,158.829051 186.732263,166.155824 164.056846,162.673392 Z",
  id: "community-a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.056846,162.673392 C135.825211,154.558193 97.6646355,158.733483 83.4010508,162.673392 C62.0056743,168.583256 44.791686,161.77826 27.6171838,138.328942 C10.4426815,114.879625 -12.6479573,99.4971716 8.39810731,56.7448024 C29.4441719,13.9924332 93.4587439,31.6211901 132.425048,27.5016118 C171.391352,23.3820336 218.311367,28.5160397 207.172048,66.1382203 C196.03273,103.760401 215.292647,113.489103 206.68131,140.693072 C200.940418,158.829051 186.732263,166.155824 164.056846,162.673392 Z",
  id: "community-i",
  fill: "#EBEAF9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "url(#linearGradient-2)",
  fillRule: "nonzero",
  cx: 27.5152201,
  cy: 56.7490211,
  rx: 7.21889981,
  ry: 6.73829982
}), /*#__PURE__*/React.createElement("rect", {
  id: "community-o",
  fill: "#7540EE",
  fillRule: "nonzero",
  x: 187.696316,
  y: 50.0107212,
  width: 26.9603993,
  height: 10.8629997,
  rx: 3.56489991
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.7963201,112.983076 C24.7963201,111.010118 26.3993364,109.41072 28.3635608,109.41072 L41.4425925,109.41072 C43.4127251,109.41072 45.0098332,111.001436 45.0098332,112.983076 L45.0098332,118.601999 C45.0098332,120.574957 43.4068169,122.174356 41.4425925,122.174356 L28.3635608,122.174356 C26.3934282,122.174356 24.7963201,120.58364 24.7963201,118.601999 L24.7963201,112.983076 Z",
  id: "community-q",
  fill: "#7540EE",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.596321,95.4815709 C165.596321,93.5094456 167.187712,91.9107222 169.163856,91.9107222 L191.242298,91.9107222 C193.212593,91.9107222 194.809833,93.5095306 194.809833,95.4815709 L194.809833,104.703509 C194.809833,106.675635 193.218442,108.274358 191.242298,108.274358 L169.163856,108.274358 C167.193561,108.274358 165.596321,106.67555 165.596321,104.703509 L165.596321,95.4815709 Z",
  id: "community-s",
  fill: "url(#linearGradient-3)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#7540EE",
  x: 59.3151653,
  y: 21.6406074,
  width: 97.8531753,
  height: 120.434677,
  rx: 7.52716733
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  x: 59.3151653,
  y: 21.6406074,
  width: 97.8531753,
  height: 120.434677,
  rx: 7.52716733
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  fill: "#FFFFFF",
  x: 68.724125,
  y: 31.0495671,
  width: 79.0352617,
  height: 100.675869,
  rx: 3.76358389
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-11-Copy-2",
  fill: "#EBEAF9",
  points: "80.9557726 59.2764463 134.586843 59.2764463 134.586843 69.6263019 80.9557726 69.6263019"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-11-Copy-2",
  fill: "#EBEAF9",
  points: "80.9557726 79.9761576 134.586843 79.9761576 134.586843 90.3260133 80.9557726 90.3260133"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-11-Copy-2",
  fill: "#EBEAF9",
  points: "80.9557726 100.675869 134.586843 100.675869 134.586843 111.025725 80.9557726 111.025725"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-2",
  fill: "#320056",
  cx: 107.865396,
  cy: 12.7961845,
  r: 12.7961845
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-7",
  fill: "#320056",
  x: 80.0148767,
  y: 17.1243056,
  width: 55.7010382,
  height: 17.3124849,
  rx: 3.76358366
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#320056",
  cx: 107.865396,
  cy: 11.8552885,
  r: 3.01086693
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 107.865396,
  cy: 13.7370804,
  r: 3.01086693
})));

var SvgClipboard = function SvgClipboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 216 165",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClipboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clipboard.7b174d71.svg";
export { ForwardRef as ReactComponent };